import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Gift } from "lucide-react";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { money } from "@/lib/daytime";

export function GiftDialog({ open, prices, onClose, onOrder }) {
  const [f, setF] = useState({ kind: "pass5", recipient_name: "", recipient_email: "", message: "" });
  const buy = async () => {
    try { const { data } = await api.post("/gifts", f); onOrder(data.order); setF({ kind: "pass5", recipient_name: "", recipient_email: "", message: "" }); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="gift-dialog">
        <DialogHeader><DialogTitle className="font-display text-navy flex items-center gap-2"><Gift className="w-5 h-5 text-coral" /> Gift a Rock Pass</DialogTitle>
          <DialogDescription>We'll email the gift code once your payment is confirmed.</DialogDescription></DialogHeader>
        <div className="grid grid-cols-2 gap-2">{[["pass5", "5-Visit Rock Pass"], ["pass10", "10-Visit Rock Pass"]].map(([k, l]) => (
          <button key={k} onClick={() => setF({ ...f, kind: k })} className={`rounded-2xl border-2 p-3 text-left ${f.kind === k ? "border-coral bg-coral/10" : "border-slate-200"}`} data-testid={`gift-kind-${k}`}>
            <p className="font-bold text-navy text-sm">{l}</p><p className="font-extrabold text-coral">{money(prices[k])}</p></button>))}</div>
        <Input placeholder="Recipient's name" value={f.recipient_name} onChange={(e) => setF({ ...f, recipient_name: e.target.value })} className="rounded-xl" data-testid="gift-name" />
        <Input type="email" placeholder="Recipient's email" value={f.recipient_email} onChange={(e) => setF({ ...f, recipient_email: e.target.value })} className="rounded-xl" data-testid="gift-email" />
        <Textarea placeholder="Your message (optional)" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className="rounded-xl" data-testid="gift-message" />
        <Button onClick={buy} className="w-full rounded-full bg-coral text-white font-bold h-12" data-testid="gift-submit">Buy gift — {money(prices[f.kind])}</Button>
      </DialogContent>
    </Dialog>
  );
}

export function RedeemGift({ initial, onRedeemed }) {
  const [code, setCode] = useState(initial || "");
  useEffect(() => { if (initial) setCode(initial); }, [initial]);
  const go = async () => {
    if (!code.trim()) return;
    try { const { data } = await api.post("/gifts/redeem", { code }); toast.success(`${data.pass.label} added to your account! 🎉`); setCode(""); onRedeemed(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div className="flex gap-2 items-center" data-testid="redeem-gift">
      <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Gift code e.g. ARG-1A2B-3C4D" className="rounded-xl max-w-xs" data-testid="redeem-code" />
      <Button onClick={go} variant="outline" className="rounded-full" data-testid="redeem-submit">Redeem gift</Button>
    </div>
  );
}
